import React from 'react'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import * as SideMenu from 'components/side-menu'
import { Tag } from 'src/design-system'
import { GraduationCap } from '@phosphor-icons/react'

export const CareerCoachLink = () => {
  const path = `/coach`
  const title = 'Coach'

  const isActive = useIsActive(path)

  return (
    <SideMenu.LinkItem
      active={isActive}
      href={path}
      analyticsProps={sideNavAnalyticsProps({
        href: path,
        title,
      })}
      icon={GraduationCap}
      data-element-id="side-nav-career-coach-link"
    >
      {title}
      {/* Recently shipped, so it gets flagged until people have found it. */}
      <Tag className="ml-auto" variant="info">
        New
      </Tag>
    </SideMenu.LinkItem>
  )
}
